import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'https://lifeautofill.com';
const BRAND = 'Life Admin Autofill';

const PUBLIC = {
  '/': {
    title: 'Life Admin Autofill: Fill Job, Rental & Government Forms in One Click',
    description: 'Turn your ID, resume and payslips into one secure Life Profile, then autofill job, rental, loan and government applications in a single click. Free to start.',
  },
  '/extension': {
    title: `Autofill Browser Extension for Chrome & Firefox | ${BRAND}`,
    description: 'Install the Life Admin Autofill extension for Chrome, Edge, Brave and Firefox. One-click autofill on Seek, realestate.com.au, gym sign-ups and more, plus Form Memory that learns every site.',
  },
  '/help': {
    title: `Help Center & FAQ | ${BRAND}`,
    description: 'Answers about document parsing, the browser extension, Form Memory, billing, refunds, data security and deleting your account.',
  },
  '/contact': {
    title: `Contact Support | ${BRAND}`,
    description: 'Get help from a real person. Email support@lifeautofill.com or send a message. We reply within 24 hours on business days.',
  },
  '/privacy': {
    title: `Privacy Policy | ${BRAND}`,
    description: 'How Life Admin Autofill collects, uses, stores and protects your personal information under the Australian Privacy Act 1988 and the Australian Privacy Principles.',
  },
  '/terms': {
    title: `Terms of Service | ${BRAND}`,
    description: 'The terms that govern your use of Life Admin Autofill, including subscriptions, acceptable use and liability.',
  },
};

const PRIVATE_TITLES = {
  '/dashboard': 'Dashboard', '/documents': 'Documents', '/applications': 'Applications',
  '/settings': 'Settings', '/admin': 'Admin', '/fill': 'Fill Helper', '/upgrade': 'Upgrade to Pro', '/packs': 'Application Packs',
};

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    const [, k, v] = selector.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/);
    el.setAttribute(k, v);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export const RouteSeo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = PUBLIC[pathname];
    const title = page?.title || `${PRIVATE_TITLES[pathname] || 'Shared Pack'} | ${BRAND}`;
    const description = page?.description || PUBLIC['/'].description;
    const url = `${SITE}${pathname === '/' ? '/' : pathname}`;

    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[name="robots"]', 'content', page ? 'index, follow' : 'noindex, nofollow');
    setMeta('link[rel="canonical"]', 'href', url);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
  }, [pathname]);

  return null;
};
